<div id="balloon-template">
    <div class="image-container" id="image-container1">
        <svg class="balloon-div" viewBox="0 0 200 520" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <linearGradient id="a">
                    <stop offset="0" stop-color="#a0dfff"></stop>
                    <stop offset="1" stop-opacity=".98" stop-color="#00a6d4"></stop>
                </linearGradient>
                <radialGradient xlink:href="#a" id="d" gradientUnits="userSpaceOnUse" gradientTransform="matrix(.92948 -.12308 .22747 1.71786 12.259 -1512.91)"
                    cx="125.696" cy="897.657" fx="125.696" fy="897.657" r="21.995">
                </radialGradient>
                <radialGradient xlink:href="#a" id="e" gradientUnits="userSpaceOnUse" gradientTransform="matrix(.1668 .22073 -.22739 .17183 234.881 -4.665)"
                    spreadMethod="pad" cx="236.824" cy="540.675" fx="236.824" fy="540.675" r="352.857">
                </radialGradient>
                <radialGradient id="b" cx=".309" cy=".344" r=".5" fx=".309" fy=".344">
                    <stop offset="0" stop-color="#aad4ff"></stop>
                    <stop offset="1" stop-color="#005fbf"></stop>
                </radialGradient>
                <radialGradient id="c" cx=".332" cy=".371" r=".5" fx=".332" fy=".371">
                    <stop offset="0" stop-color="#ceffff"></stop>
                    <stop offset="1" stop-color="#0ff"></stop>
                </radialGradient>

                <radialGradient id="f" cx=".309" cy=".344" r=".5" fx=".309" fy=".344">
                    <stop offset="0" stop-color="#ebe9f9"></stop>
                    <stop offset="1" stop-color="#c1bfea"></stop>
                </radialGradient>
                <radialGradient id="g" cx=".332" cy=".371" r=".5" fx=".332" fy=".371">
                    <stop offset="0" stop-color="#ff94cd"></stop>
                    <stop offset="1" stop-color="#d60072"></stop>
                </radialGradient>
                <radialGradient id="h" cx=".332" cy=".371" r=".5" fx=".332" fy=".371">
                    <stop offset="0" stop-color="#ff8e7a"></stop>
                    <stop offset="1" stop-color="#e83e2e"></stop>
                </radialGradient>
                <radialGradient id="i" cx=".309" cy=".344" r=".5" fx=".309" fy=".344">
                    <stop offset="0" stop-color="#ff910a"></stop>
                    <stop offset="1" stop-color="#ff4c5b"></stop>
                </radialGradient>
                <radialGradient id="j" cx=".332" cy=".371" r=".5" fx=".332" fy=".371">
                    <stop offset="0" stop-color="#f1e867"></stop>
                    <stop offset="1" stop-color="#feb745"></stop>
                </radialGradient>
                <radialGradient id="k" cx=".332" cy=".371" r=".5" fx=".332" fy=".371">
                    <stop offset="0" stop-color="#b67aff"></stop>
                    <stop offset="1" stop-color="#6a51f7"></stop>
                </radialGradient>
            </defs>
            <path class="balloon-body" d="M104.427 254.144c2.234-.268 17.755 20.446 16.87 22.516-.885 2.07-26.585 5.153-27.935 3.352-1.35-1.801 8.83-25.6 11.065-25.868z"></path>
            <path class="balloon-body" d="M189.67 146.77c0 47.34-42.277 118.016-85.76 118.016-44.773 0-85.76-70.677-85.76-118.016 0-47.34 38.42-90.921 85.76-90.921s85.76 43.581 85.76 90.92z"
                ></path>
            <path d="M97.33 265.111c5.402-1.114 9.198-2.253 16.288-.605 8.719 103.13 64.981 151.473 89.304 244.41 1.892 7.228-.898 19.215.63 26.971"
                stroke-linejoin="round" stroke-linecap="round" stroke-width="3" stroke="#4e4131" fill="none"></path>
        </svg>

        <div class="balloon-gradient"></div>
    </div>
</div>
<div id="sky-content"></div>